import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateHelper } from '@app/_helpers';
import { MobileMenuItem } from '@interfaces/mobile-menu-item';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '@app/_services/shared.service';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { RouterLink } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';
import { CollapseDirective, CollapseItemDirective, CollapseContentDirective } from '../../../../shared/directives/collapse.directive';

@Component({
    selector: 'app-mobile-links',
    templateUrl: './mobile-links.component.html',
    styleUrls: ['./mobile-links.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [CollapseDirective, NgFor, CollapseItemDirective, RouterLink, NgIf, IconComponent, CollapseContentDirective]
})
export class MobileLinksComponent {
    @Input() links: any[] = [];
    @Input() level = 0;
    @Input() type;

    @Output() itemClick: EventEmitter<MobileMenuItem> = new EventEmitter();
    sector;
    constructor(public translate: TranslateService,
        public translateHelper: TranslateHelper, private shareService: SharedService) { this.sector = this.shareService.page; }

    onItemClick(item: MobileMenuItem): void {
        this.itemClick.emit(item);
    }
}
